import React from 'react';

const GameCategoryPage = () => {
  return (
    <React.Fragment>
      <div>category page</div>
    </React.Fragment>
  );
};

export default GameCategoryPage;
